import * as React from "react";
import classNames = require("classnames");
import {loading} from "../../../contract-download/selectors";

interface CellState {
}

interface CellProps {
    value: string;
    hasFocus: boolean;
    loading?: boolean;
    icon?: {
        name: string;
        title: string;
        action: () => void;
    }
}


export default class ReadOnlyCell extends React.Component<CellProps, CellState> {

    render() {
        let {value, hasFocus, icon, loading} = this.props;
        let cellValueClasses = classNames({
            'cell-component': true,
            'cell-focus': hasFocus,
            'disabled': true,
            'hasAction': icon !== undefined
        });

        return (
            <div title={icon?.title} className={cellValueClasses} onClick={icon?.action}>
                {loading ? 'Laster inn' : icon ? <span className={"action glyphicon " + icon.name}/> : null} {value}
            </div>
        );
    }

}



